export default __webpack_public_path__ + "static/media/hedge_inactive.babc9d95.svg";